/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLayersSelectedBottom = createReactComponent("outline", "layers-selected-bottom", "IconLayersSelectedBottom", [["path", { "d": "M4 14.5l4 -4", "key": "svg-0" }], ["path", { "d": "M9.496 20l4.004 -4z", "key": "svg-1" }], ["path", { "d": "M4.586 19.414l3.914 -3.914", "key": "svg-2" }], ["path", { "d": "M8 6a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z", "key": "svg-3" }], ["path", { "d": "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2", "key": "svg-4" }]]);

export { IconLayersSelectedBottom as default };
//# sourceMappingURL=IconLayersSelectedBottom.mjs.map
